import type { FundDatum } from "@/FundExplorer/types";
import { ValtechSiteAudienceIdMap, queryParamsToOmit } from "@/constants";

export function isOnFundPage(url: URL, audienceId?: string) {
	const pathSegments = url.pathname.split("/").filter((segment) => !!segment);
	const isInternational = ValtechSiteAudienceIdMap.International.includes(
		Number.parseInt(`${audienceId}`),
	);
	console.log("isInternational", isInternational);

	if (isInternational && pathSegments.length > 5) {
		return true;
	}
	if (!isInternational && pathSegments.length > 4) {
		return true;
	}
	return false;
}

export default function getFundURL(
	fund: FundDatum,
	audienceId?: string,
	fundPage?: boolean,
) {
	const isInstitutional = ValtechSiteAudienceIdMap.Institutional.includes(
		Number.parseInt(`${audienceId}`),
	);
	const altURL = `${fund.altURL}`.trim();
	const instURL = `${fund.instURL}`.trim();
	if (!!altURL && altURL.length > 1) return isInstitutional ? instURL : altURL;

	const fundURL = `${fund.fundPageURL}`.trim();
	if (!fundURL || fundURL.length === 0) return null;

	const fundNameIndex = fundURL.endsWith("/") ? -2 : -1;
	const fundName = fundURL.split("/").at(fundNameIndex) ?? "";

	const url = new URL(window.location.href);
	const pathname = isOnFundPage(url, audienceId)
		? `/${url.pathname
				.split("/")
				.filter((p) => !!p)
				.slice(0, -1)
				.join("/")}`
		: url.pathname;

	const slash = pathname.endsWith("/") ? "" : "/";
	url.pathname = `${pathname}${slash}${fundName}/`;

	const santisedUrl = sanitiseUrl(url);

	return santisedUrl.toString();
}

export const sanitiseUrl = (url: URL) => {
	const newURl = new URL(url);
	const searchParams = new URLSearchParams(newURl.search);

	const newSearchParams = new URLSearchParams();
	// Add the current search parameters to the new searchParams object we creat from the query params we want to keep
	for (const key of queryParamsToOmit) {
		if (searchParams.has(key)) {
			newSearchParams.set(key, searchParams.get(key) as string);
		}
	}

	// Update the URL with the new search parameters
	newURl.search = newSearchParams.toString();

	newURl.hash = ""; // Remove hash

	return newURl;
};
